import {
  faCaretDown,
  faChevronUp,
  faExclamationCircle,
  faExclamationTriangle,
  faSortDown,
  faSortUp,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, Formik, useFormikContext } from "formik";
import { isEmpty } from "lodash";
import React from "react";
import { useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { useDeepEffect } from "../../../abstracts";
import InfiniteScroll from "react-infinite-scroller";
import {
  FieldDropSide,
  FieldInput,
  FormControlSearch,
  LoaderWrapper,
  MultiSelectDropdown,
  SearchableList,
} from "../../../components";
import { getFeeSpecificationBasedOnSearchCriteria } from "../../../services";
import {
  OPTIONS_DATA_MAPPER,
  toMultiSelectValueById,
  toOptionValuesFromMapper,
} from "../../../utils";
import AddSpecificationInformationContainer from "./AddSpecificationInformationContainer";
import SpecificationInformationCard from "./SpecificationInformationCard";

const data = [
  {
    Name: "$ 1000 Plan",
    Description:
      "$ 1000 pro - rate across all participants fixed amount payroll processing fee",
    AllocationType: "Fixed Amount",
  },
  {
    Name: "$ 4500 Plan",
    Description: "$ 5 if balance between 5000 to 10000",
    AllocationType: "Tiered",
  },
  {
    Name: "$ 5480 Plan",
    Description: "-",
    AllocationType: "Percentage",
  },
  {
    Name: "$ 6540 Plan",
    Description: "$ 2000 pro - rate across all participants",
    AllocationType: "Fixed Amount",
  },
  {
    Name: "$ 170000 Plan",
    Description: "$ 2000 pro - rate across all participants",
    FeeType: "Investment based",
    AllocationType: "Tiered",
  },
];

const allOption = { label: "All", value: null };

const AddSpecificationSlider = ({
  addSpecificationdata,
  setAddSpecificationData,
  fields,
  showErrorMessage,
  setShowErrorMessage,
  setLoading,
  loading,
  specLoading,
  setSpecLoading,
}) => {
  const { values, handleChange, setFieldValue } = useFormikContext();
  const sorterUp = (sortBy) => (a, b) =>
    a[sortBy].toLowerCase() > b[sortBy].toLowerCase() ? 1 : -1;
  const sorterDown = (sortBy) => (a, b) =>
    a[sortBy].toLowerCase() < b[sortBy].toLowerCase() ? 1 : -1;
  const cardHeader = [
    {
      label: "Name",
      columnName: "Name",
      width: "66.8%",
    },
    {
      label: "Description",
      columnName: "Description",
      width: "73.3%",
    },
    {
      label: "Allocation Type",
      columnName: "AllocationType",
      width: "56.3%",
    },
  ];

  const [feeRequest, setFeeRequest] = useState({
    feeType: [values[fields.feeType]],
    searchString: "",
    allocationType: null,
    from: 0,
    to: 20,
    count: 0,
  });

  const onClickSave = () => {
    // const clearAddSpecificationData = async () => {
    //   setAddSpecificationData([]);
    // };
    // await clearAddSpecificationData();
    setFeeRequest({
      ...feeRequest,
      searchString: values[fields.specificationName],
      allocationType: values[fields.allocationType] || null,
      feeType: [values[fields.feeType]],
      from: 0,
      to: 20,
      count: 0,
    });
  };

  console.log("addSpecificationdata", addSpecificationdata);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  useDeepEffect(() => {
    setLoading(true);
    getFeeSpecificationBasedOnSearchCriteria(feeRequest)
      .then((response) => {
        if (response?.feeSpecificationInformationDetails?.length < 20)
          setStopInfiniteScroll(true);
        if (append) {
          setAddSpecificationData((feeSpecList) => {
            return [
              ...feeSpecList,
              ...response?.feeSpecificationInformationDetails,
            ];
          });
        } else {
          setAddSpecificationData(response?.feeSpecificationInformationDetails);

          console.log("county", addSpecificationdata);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
    // }
  }, [feeRequest]);

  console.log();
  return (
    <>
      <p className="ft-20 fw-600" style={{ marginTop: "-80px" }}>
        Add Specification
        <p className="fw-600 ft-14 grey">
          {addSpecificationdata.length < 10 &&
          addSpecificationdata.length !== 0 ? (
            <p className="fw-600 ft-14 grey">
              0{addSpecificationdata.length} Records Found
            </p>
          ) : (
            <p className="fw-600 ft-14 grey">
              {addSpecificationdata.length} Records Found
            </p>
          )}
        </p>
      </p>
      <hr />
      <LoaderWrapper isLoading={loading}>
        <div className="displayCard">
          <FontAwesomeIcon className="ml-2" icon={faExclamationCircle} />
          <span className="ml-2">
            {`Displaying only ${
              values.feeType == 1 ? "Balance based" : "Investment based"
            } fee types as per your selection`}
          </span>
        </div>
        <br />
        {showErrorMessage && (
          <div style={{ color: "red" }}>
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              size="xs"
              style={{ color: "red" }}
            />
            FE011: Choose any Specification to proceed
          </div>
        )}

        <br />

        <div className="d-flex align-item-center pad-50-right justify-content-between">
          <div className="d-flex">
            <label
              className="fw-600 ft-14"
              style={{ whiteSpace: "nowrap", color: "#919191" }}
            >
              Search Specification
            </label>
            <InputGroup>
              <InputGroup.Prepend>
                <div
                  className="search-icon-postion"
                  style={{ marginLeft: "-130px", marginTop: "37px" }}
                >
                  <i class="fas fa-search" aria-hidden="true"></i>
                </div>
              </InputGroup.Prepend>

              <FormControlSearch
                size="xs"
                type="search"
                style={{
                  borderRadius: "5px",
                  width: "15rem",
                  marginTop: "27px",
                  marginLeft: "-135px",
                  paddingLeft: "30px",
                }}
                placeholder="Search Specification name"
                onChange={(e) =>
                  setFieldValue(fields.specificationName, e.target.value)
                }
              />
            </InputGroup>
            <label
              className="ml-4 fw-600 ft-14"
              style={{ color: "#919191", whiteSpace: "nowrap" }}
            >
              Allocation type
            </label>
            <div
              className="d-flex"
              style={{ marginTop: "27px", marginLeft: "-100px" }}
            >
              <Field
                size="sm"
                placeholder="All"
                name={fields.allocationType}
                value={toMultiSelectValueById(
                  values[fields.allocationType],
                  toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.ALLOCATION_TYPE)
                )}
                isMultiSelect
                isRequired
                direction="bottom"
                popupContent={
                  <MultiSelectDropdown
                    label="Select Allocation Type"
                    name={fields.allocationType}
                    onSelect={(value) => {
                      setFieldValue(fields.allocationType, value);
                    }}
                    value={values[fields.allocationType]}
                    options={toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.ALLOCATION_TYPE
                    )}
                  />
                }
                component={FieldDropSide}
              />
            </div>
            <div className="ml-3 mt-4">
              <Button onClick={() => onClickSave()}>Search</Button>
            </div>
          </div>
        </div>

        {!isEmpty(addSpecificationdata) ? (
          <>
            <div
              className="payroll-columns w-100"
              style={{ display: "flex", marginLeft: "20px" }}
            >
              {cardHeader.map((item, ind) => (
                <div
                  className="fw-600 ft-14 grey"
                  style={{ width: item?.width }}
                >
                  {item?.label}{" "}
                </div>
              ))}
            </div>
            <div
              style={{
                paddingRight: "1vh",
                height: "65vh",
                overflow: "scroll",
              }}
            >
              <InfiniteScroll
                pageStart={0}
                loadMore={() => {
                  setAppend(true);
                  setFeeRequest((filterData) => {
                    return {
                      ...feeRequest,
                      from: addSpecificationdata?.length,
                    };
                  });
                }}
                hasMore={!stopInfiniteScroll}
                initialLoad={false}
                threshold={100}
                useWindow={false}
                loader={
                  addSpecificationdata.length != 0 && (
                    <div className="loader" key={0}>
                      Loading ...
                    </div>
                  )
                }
              >
                {addSpecificationdata?.map((item, index) => {
                  return (
                    <div>
                      <AddSpecificationInformationContainer
                        specificationData={item}
                        values={values}
                        fields={fields}
                        setFieldValue={setFieldValue}
                      />
                    </div>
                  );
                })}
              </InfiniteScroll>
            </div>
          </>
        ) : (
          <div
            className="fw-400 ft-18"
            style={{ textAlign: "center", marginTop: "15%" }}
          >
            {"No matches found"}
          </div>
        )}
      </LoaderWrapper>
    </>
  );
};

export default AddSpecificationSlider;
